import { useSelector } from "react-redux";
import Loader from "./legacy/components/loader";
import Layout from "./v2/app/layouts/AppLayout";

const useAuth = () => {
  const user = useSelector((state) => state.isLogin);
  const users = useSelector((state) => state.users);
  const isloading = useSelector((state) => state.isLoading);
  return {
    user,
    isloading,
    users,
  };
};

const RootLayout = () => {
  const isAuth = useAuth();

  if (isAuth.user) {
    return <Layout />
  } else if (isAuth.isloading) {
    return <Loader />
  } else {
    return <Loader />
  }
};
export default RootLayout;
